module.exports = __webpack_public_path__ + "img/SES_130250600.305ad629.jpg";